import { render, staticRenderFns } from "./tplSearch.vue?vue&type=template&id=c9e40018&scoped=true"
import script from "./tplSearch.vue?vue&type=script&lang=ts"
export * from "./tplSearch.vue?vue&type=script&lang=ts"
import style0 from "./tplSearch.vue?vue&type=style&index=0&id=c9e40018&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e40018",
  null
  
)

/* custom blocks */
import block0 from "./tplSearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports